export default "__VITE_ASSET__CkwpYKBn__"